"use client";

import type { FontWeight } from "@homeinstead/schemas";
import type { ButtonColorVariant } from "./button-styles";

import { cn } from "@homeinstead/ui";
import { Button } from "@homeinstead/ui/components/Button";
import { useFormStatus } from "react-dom";
import { COLOR_VARIANT_MAP, FONT_WEIGHT_CLASS } from "./button-styles";

interface SubmitButtonProps {
  colorVariant?: ButtonColorVariant | null;
  fontWeight?: FontWeight | null;
  isSubmitting?: boolean;
  label?: string | null;
}

export function SubmitButton({
  colorVariant,
  fontWeight,
  isSubmitting,
  label,
}: SubmitButtonProps) {
  const { pending: formPending } = useFormStatus();
  const pending = isSubmitting ?? formPending;

  return (
    <Button
      aria-busy={pending}
      className={cn("w-full", fontWeight && FONT_WEIGHT_CLASS[fontWeight])}
      disabled={pending}
      loading={pending}
      type="submit"
      variant={colorVariant ? COLOR_VARIANT_MAP[colorVariant] : undefined}
    >
      {pending ? (
        <span
          aria-hidden="true"
          className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          data-testid="submit-spinner"
        />
      ) : null}
      {label ?? "Submit"}
    </Button>
  );
}
